import comp from "./EditOrgInfo";
export default comp;
